export default {
    config: {
        title: 'Data',
        inputLabel: 'CDS API key',
        copySuccessMessage: 'API successfuly copied!',
        alertMessage: 'Please choose subscription on page',
    },
};
